/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IRegulationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IRegulationsQuery = {
  __typename?: 'Query';
  internalRegulations: {
    __typename: 'InternalRegulationsConnection';
    edges: Array<{
      __typename: 'InternalRegulationEdge';
      cursor: string;
      node: { __typename: 'InternalRegulation'; id?: string | null; title: string };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const RegulationsDocument = gql`
  query Regulations($input: InternalRegulationsInput, $first: Int, $after: String) {
    internalRegulations(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          title
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useRegulationsQuery__
 *
 * To run a query within a React component, call `useRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegulationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRegulationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IRegulationsQuery, IRegulationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IRegulationsQuery, IRegulationsQueryVariables>(RegulationsDocument, options);
}
export function useRegulationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IRegulationsQuery, IRegulationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IRegulationsQuery, IRegulationsQueryVariables>(RegulationsDocument, options);
}
// @ts-ignore
export function useRegulationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IRegulationsQuery, IRegulationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IRegulationsQuery, IRegulationsQueryVariables>;
export function useRegulationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IRegulationsQuery, IRegulationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<IRegulationsQuery | undefined, IRegulationsQueryVariables>;
export function useRegulationsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IRegulationsQuery, IRegulationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IRegulationsQuery, IRegulationsQueryVariables>(RegulationsDocument, options);
}
export type RegulationsQueryHookResult = ReturnType<typeof useRegulationsQuery>;
export type RegulationsLazyQueryHookResult = ReturnType<typeof useRegulationsLazyQuery>;
export type RegulationsSuspenseQueryHookResult = ReturnType<typeof useRegulationsSuspenseQuery>;
export type RegulationsQueryResult = Apollo.QueryResult<IRegulationsQuery, IRegulationsQueryVariables>;
